module.exports = __webpack_public_path__ + "static/media/texture (44).a52778a4.jpg";